import React from "react"
import { useLabels } from "../../../../../features/contents/hooks"
import CustomButton from "../../../../../ui/atoms/Button"
import Typography from "../../../../../ui/atoms/Typography"
import { CustomDialog } from "../../../../../ui/molecules/Dialog/CustomDialog"
import { useAlgoliaSearchState } from "../../controller/state"
import FiltersModalContent from "../FiltersModalContent"
import FiltersModalHead from "../FiltersModalHead"
import { SelectedFilterCategory } from "../types"

interface Props {
  open: boolean
  onClose: () => void
}

const FiltersModal = ({ open, onClose }: Props) => {
  const { searchResults, clearFilters } = useAlgoliaSearchState()
  const { getLabel } = useLabels()

  const [
    selectedCategory,
    setSelectedCategory,
  ] = React.useState<SelectedFilterCategory>()

  return (
    <div>
      <CustomDialog
        open={open}
        onClose={onClose}
        fullScreenAll
        noGutters
        // unmount={false}
      >
        <div
          className="fixed top-0 left-0 w-full py-2 text-center bg-disabled"
          style={{
            zIndex: 100,
          }}
        >
          <Typography variant="body1">
            {getLabel("search", "filter-for").toUpperCase()}
          </Typography>
        </div>
        {!selectedCategory && (
          <FiltersModalHead onBack={onClose} onReset={clearFilters} />
        )}
        <div className="px-2 pt-8 pb-14">
          <FiltersModalContent
            selectedCategory={selectedCategory}
            onSelectedCategoryChange={setSelectedCategory}
            onSelectedCategoryClear={() => setSelectedCategory(undefined)}
          />
        </div>
        <div className="fixed bottom-0 flex items-center w-full px-5 py-1 bg-white z-1">
          <CustomButton fullWidth onClick={onClose}>
            {getLabel("search", "show-products")} ({searchResults?.nbHits ?? 0})
          </CustomButton>
        </div>
      </CustomDialog>
    </div>
  )
}

export default FiltersModal
